export interface RuntimeConfig {
  applicationInsightsConnectionString: string
  sentryDsn: string
  logRocketProject: string
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Partial<RuntimeConfig>
  }
}

/**
 * @todo (vue3): Uses `process.env.*` instead of `import.meta.env` only because
 *       Jest cannot parse import.meta, and this module is reachable from
 *       hundreds of specs. Switch when tests move to Vitest; the `define`
 *       block in vite.config.mts is what keeps this working.
 */
const fallbackConfig: RuntimeConfig = {
  applicationInsightsConnectionString:
    process.env.VUE_APP_APPLICATIONINSIGHTS_CONNECTION_STRING || '',
  sentryDsn: process.env.VUE_APP_SENTRY_DSN || '',
  logRocketProject: process.env.VUE_APP_LOGROCKET_PROJECT || '',
}

const injected = (typeof window !== 'undefined' ? window.__RUNTIME_CONFIG__ : undefined) ?? {}

const runtimeConfig: RuntimeConfig = {
  applicationInsightsConnectionString:
    injected.applicationInsightsConnectionString ||
    fallbackConfig.applicationInsightsConnectionString,
  sentryDsn: injected.sentryDsn || fallbackConfig.sentryDsn,
  logRocketProject: injected.logRocketProject || fallbackConfig.logRocketProject,
}

export function getRuntimeConfig(): RuntimeConfig {
  return runtimeConfig
}
